<div class="quickstart-container">
    <div *ngIf="isQuickstartDone" class="completion-banner">
        <div class="confetti">
            <img class="high-five" src="/assets/illustrations/high-five-hq.png" alt="high-five" />
        </div>
        <div class="content">
            <h2 class="margin-top-2">{{ 'self-serve.quickstart.wellDoneCompleted' | translate }}</h2>
            <p class="subtext margin-bottom-2" [innerHtml]="'self-serve.quickstart.wantToTakeDaily' | translate"></p>
            <div>
                <ui-button (click)="dismissQuickstart()" type="primary"
                    >{{ 'self-serve.quickstart.dismissQuickstart' | translate }}
                </ui-button>
            </div>
        </div>
    </div>

    <ui-card [class.loading]="isLoading">
        <div class="flex">
            <div class="component-header margin-bottom-1">
                <h3 *ngIf="onboardingStatus && onboardingStatus.quickstartType">
                    {{
                        (onboardingStatus.quickstartType === 'HR_PAYROLL' ||
                        onboardingStatus.quickstartType === 'HR_PAYROLL_TIMEOFF'
                            ? 'self-serve.quickstart.quickstartWithHumiPayroll'
                            : 'self-serve.quickstart.quickstartWithHumi'
                        ) | translate
                    }}
                </h3>
                <div class="progress-bar-container">
                    <mat-progress-bar
                        class="green-fill"
                        mode="determinate"
                        [value]="(stepsCompleted / totalSteps) * 100"
                    ></mat-progress-bar>
                    <div class="subtext only-small">{{ stepsCompleted }} / {{ totalSteps }}</div>
                    <div class="subtext hide-small">
                        {{
                            'self-serve.quickstart.completedSteps'
                                | translate: { completed: stepsCompleted, totalSteps: totalSteps }
                        }}
                    </div>
                </div>
            </div>
        </div>

        <p class="subtext">{{ 'self-serve.quickstart.setupYourAccountWithEase' | translate }}</p>

        <!-- The two quickstart dashboards with payroll look very similar.-->
        <!-- The only difference is the inclusion of time off. -->
        <!-- For the time off only quickstart dashboard, see below -->
        <mat-accordion
            role="list"
            *ngIf="
                !isLoading &&
                onboardingStatus &&
                (onboardingStatus.quickstartType === 'HR_PAYROLL' ||
                    onboardingStatus.quickstartType === 'HR_PAYROLL_TIMEOFF')
            "
        >
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="payroll-situation complete"
                [expanded]="initiallyExpandedStep === 'payrollSituation'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span class="some-progress">1</span>
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="100"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div>
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.payrollSituation.targetDate | appDate: 'EEE, MMM d' }}
                            </div>
                            <div class="title">
                                {{ 'self-serve.payrollSituation.tellUsAboutYourPayrollSituation' | translate }}
                            </div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <mat-action-row>
                        <ui-button type="outline" (click)="trackSelfServeEditPayroll()">{{
                            'edit' | translate
                        }}</ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="get-ready-to-pay-team"
                [ngClass]="{ complete: onboardingStatus.payYourTeam.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'payYourTeam'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span [ngClass]="{ 'some-progress': onboardingStatus.payYourTeam.percentageComplete > 0 }"
                                >2</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.payYourTeam.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div class="header-with-badge">
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.payYourTeam.targetDate | appDate: 'EEE, MMM d' }}
                                <ui-badge *ngIf="onboardingStatus.payYourTeam.isOverdue" type="warning">{{
                                    'self-serve.overdue' | translate
                                }}</ui-badge>
                            </div>
                            <div class="title">{{ 'self-serve.payYourTeam.getReadyToPayYourTeam' | translate }}</div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.payYourTeam.percentageComplete === 0"
                            type="primary"
                            class="pay"
                            (click)="navigateTo('pay-your-team')"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="
                                onboardingStatus.payYourTeam.percentageComplete > 0 &&
                                onboardingStatus.payYourTeam.percentageComplete < 100
                            "
                            type="primary"
                            url="pay-your-team"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.payYourTeam.percentageComplete === 100"
                            type="outline"
                            url="pay-your-team"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="book-call"
                [ngClass]="{ complete: onboardingStatus.bookACall.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'bookACall'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span [ngClass]="{ 'some-progress': onboardingStatus.bookACall.percentageComplete > 0 }"
                                >3</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.bookACall.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div class="header-with-badge">
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.bookACall.targetDate | appDate: 'EEE, MMM d' }}
                                <ui-badge *ngIf="onboardingStatus.bookACall.isOverdue" type="warning">{{
                                    'self-serve.overdue' | translate
                                }}</ui-badge>
                            </div>
                            <div class="title">{{ 'self-serve.bookACall.bookYourCall' | translate }}</div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <ui-banner class="margin-bottom-2" *ngIf="onboardingStatus.bookACall.cxMeetingAt"
                        >🗓️ {{ onboardingStatus.bookACall.cxMeetingAt | appDate: 'long' }}</ui-banner
                    >

                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.bookACall.percentageComplete !== 100"
                            type="primary"
                            (click)="
                                onboardingStatus.payYourTeam.percentageComplete === 100 && navigateTo('book-a-call')
                            "
                            [disabled]="onboardingStatus.payYourTeam.percentageComplete !== 100"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.bookACall.percentageComplete === 100"
                            type="outline"
                            url="book-a-call"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="payroll-documents"
                [ngClass]="{ complete: onboardingStatus.payrollDocuments.isComplete }"
                [expanded]="initiallyExpandedStep === 'payrollDocuments'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span
                                [ngClass]="{
                                    'some-progress': onboardingStatus.payrollDocuments.percentageComplete > 0,
                                }"
                                >4</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.payrollDocuments.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div class="header-with-badge">
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.payrollDocuments.targetDate | appDate: 'EEE, MMM d' }}
                                <ui-badge *ngIf="onboardingStatus.payrollDocuments.isOverdue" type="warning">{{
                                    'self-serve.overdue' | translate
                                }}</ui-badge>
                            </div>
                            <div class="header-with-badge">
                                <div
                                    class="title"
                                    translate="self-serve.payrollDocuments.{{
                                        isKYBEnabled() ? 'completeAuthorizationDocuments' : 'preparePayrollDocuments'
                                    }}"
                                ></div>
                                <ui-badge
                                    *ngIf="onboardingStatus.payrollDocuments.totalDocumentStatus === 'ready_for_review'"
                                    type="warning"
                                    >{{ 'self-serve.payrollDocuments.inReview' | translate }}</ui-badge
                                >
                                <ui-badge
                                    *ngIf="onboardingStatus.payrollDocuments.totalDocumentStatus === 'rejected'"
                                    type="danger"
                                    >{{ 'self-serve.payrollDocuments.rejected' | translate }}</ui-badge
                                >
                                <ui-badge
                                    *ngIf="onboardingStatus.payrollDocuments.totalDocumentStatus === 'verified'"
                                    type="success"
                                    >{{ 'self-serve.payrollDocuments.approved' | translate }}</ui-badge
                                >
                            </div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <ui-banner
                        class="margin-bottom-2"
                        *ngIf="
                            onboardingStatus.payrollDocuments.totalDocumentStatus === 'new' &&
                            !onboardingStatus.isCompanyOnPayroll
                        "
                        variant="info"
                        >{{ 'self-serve.payrollDocuments.ableToSubmitAfter' | translate }}</ui-banner
                    >
                    <ui-banner
                        class="margin-bottom-2"
                        *ngIf="onboardingStatus.payrollDocuments.totalDocumentStatus === 'ready_for_review'"
                        [showIcon]="true"
                        variant="info"
                        >{{ 'self-serve.payrollDocuments.humiIsReviewing' | translate }}</ui-banner
                    >
                    <ui-banner
                        class="margin-bottom-2"
                        *ngIf="onboardingStatus.payrollDocuments.totalDocumentStatus === 'rejected'"
                        [showIcon]="true"
                        variant="warning"
                        >{{ 'self-serve.payrollDocuments.documentsRejected' | translate }}</ui-banner
                    >
                    <mat-action-row>
                        <!-- if the user hasn't started yet  -->
                        <ui-button
                            *ngIf="
                                onboardingStatus.payrollDocuments.percentageComplete === 0 &&
                                onboardingStatus.payrollDocuments.totalDocumentStatus === 'new' &&
                                onboardingStatus.isCompanyOnPayroll
                            "
                            type="primary"
                            (click)="navigateTo('payroll-documents')"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <!-- if the user has started, but not completed, and there are no rejections -->
                        <ui-button
                            *ngIf="
                                onboardingStatus.payrollDocuments.percentageComplete > 0 &&
                                onboardingStatus.payrollDocuments.percentageComplete < 100 &&
                                onboardingStatus.payrollDocuments.totalDocumentStatus === 'new'
                            "
                            type="primary"
                            url="payroll-documents"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <!-- every other situation -->
                        <ui-button
                            *ngIf="
                                onboardingStatus.payrollDocuments.totalDocumentStatus !== 'new' ||
                                !onboardingStatus.isCompanyOnPayroll
                            "
                            type="outline"
                            url="payroll-documents"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>

            <!-- this is the time off card for the payroll time off flow -->
            <!-- we use a different card for the hr time off flow because they aren't the same -->
            <mat-expansion-panel
                *ngIf="onboardingStatus.quickstartType === 'HR_PAYROLL_TIMEOFF'"
                role="listitem"
                hideToggle="true"
                class="time-off"
                [ngClass]="{ complete: onboardingStatus.timeOff.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'timeOff'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span [ngClass]="{ 'some-progress': onboardingStatus.timeOff.percentageComplete > 0 }"
                                >5</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.timeOff.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div class="header-with-badge">
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.timeOff.targetDate | appDate: 'EEE, MMM d' }}
                                <ui-badge *ngIf="onboardingStatus.timeOff.isOverdue" type="warning">{{
                                    'self-serve.overdue' | translate
                                }}</ui-badge>
                            </div>
                            <div class="title">{{ 'self-serve.quickstart.setupTimeOff' | translate }}</div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.timeOff.percentageComplete === 0"
                            (click)="trackSelfServeTimeOffClickSetItUp()"
                            type="primary"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="
                                onboardingStatus.timeOff.percentageComplete > 0 &&
                                onboardingStatus.timeOff.percentageComplete < 100
                            "
                            type="primary"
                            url="/time-off/v3/types-and-policies"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.timeOff.percentageComplete === 100"
                            type="outline"
                            (click)="navigateTo('time-off')"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel
                role="listitem"
                [disabled]="true"
                hideToggle="true"
                class="run-payroll"
                [ngClass]="{ complete: onboardingStatus.runFirstPayroll.isComplete }"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <!-- the number of the step depends on which of the two flows -->
                            <span>{{ onboardingStatus.quickstartType === 'HR_PAYROLL_TIMEOFF' ? '6' : '5' }}</span>
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div>
                            <div class="header-with-badge">
                                {{ 'self-serve.by' | translate }}
                                {{ onboardingStatus.runFirstPayroll.targetDate | appDate: 'EEE, MMM d' }}
                                <ui-badge *ngIf="onboardingStatus.runFirstPayroll.isOverdue" type="warning">{{
                                    'self-serve.overdue' | translate
                                }}</ui-badge>
                            </div>
                            <div class="title">{{ 'self-serve.quickstart.runYourFirstPayroll' | translate }}</div>
                        </div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- The time off only quickstart dashboard-->
        <mat-accordion
            *ngIf="!isLoading && onboardingStatus && onboardingStatus.quickstartType === 'HR_TIMEOFF'"
            role="list"
            class="hr-time-off-only"
        >
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="company-details"
                [ngClass]="{ complete: onboardingStatus.companyDetails.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'companyDetails'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span
                                [ngClass]="{ 'some-progress': onboardingStatus.companyDetails.percentageComplete > 0 }"
                                >1</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.companyDetails.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="title">{{ 'self-serve.companyDetails.addCompanyDetails' | translate }}</div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.companyDetails.percentageComplete < 100"
                            type="primary"
                            (click)="navigateTo('company-details')"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.companyDetails.percentageComplete === 100"
                            type="outline"
                            url="company-details"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="add-your-team"
                [ngClass]="{ complete: onboardingStatus.addYourTeam.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'addYourTeam'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span [ngClass]="{ 'some-progress': onboardingStatus.addYourTeam.percentageComplete > 0 }"
                                >2</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.addYourTeam.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="title">{{ 'self-serve.addYourTeam.addYourTeam' | translate }}</div>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.addYourTeam.percentageComplete === 0"
                            type="primary"
                            (click)="
                                onboardingStatus.companyDetails.percentageComplete === 100 &&
                                    navigateTo('add-your-team')
                            "
                            [disabled]="onboardingStatus.companyDetails.percentageComplete !== 100"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="
                                onboardingStatus.addYourTeam.percentageComplete > 0 &&
                                onboardingStatus.addYourTeam.percentageComplete < 100
                            "
                            type="primary"
                            url="add-your-team"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.addYourTeam.percentageComplete === 100"
                            type="outline"
                            url="add-your-team"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>

            <!-- this is the time off card for the hr time off flow -->
            <!-- we use a different card for the payroll time off flow because they aren't the same -->
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="time-off"
                [ngClass]="{ complete: onboardingStatus.timeOff.percentageComplete === 100 }"
                [expanded]="initiallyExpandedStep === 'timeOff'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span [ngClass]="{ 'some-progress': onboardingStatus.timeOff.percentageComplete > 0 }"
                                >3</span
                            >
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                [value]="onboardingStatus.timeOff.percentageComplete"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="title">{{ 'self-serve.quickstart.setupTimeOff' | translate }}</div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            *ngIf="onboardingStatus.timeOff.percentageComplete === 0"
                            type="primary"
                            (click)="navigateTo('time-off')"
                        >
                            {{ 'self-serve.quickstart.letsDoIt' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="
                                onboardingStatus.timeOff.percentageComplete > 0 &&
                                onboardingStatus.timeOff.percentageComplete < 100
                            "
                            type="primary"
                            url="/time-off/v3/types-and-policies"
                        >
                            {{ 'self-serve.quickstart.continue' | translate }}
                        </ui-button>
                        <ui-button
                            *ngIf="onboardingStatus.timeOff.percentageComplete === 100"
                            type="outline"
                            url="/time-off/v3/types-and-policies"
                        >
                            {{ 'self-serve.quickstart.view' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                role="listitem"
                hideToggle="true"
                class="invite-your-team"
                [ngClass]="{ complete: onboardingStatus.sendInvitations.isComplete }"
                [expanded]="initiallyExpandedStep === 'inviteYourTeam'"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="bullet circle">
                            <span>4</span>
                            <mat-progress-spinner
                                class="green-fill"
                                mode="determinate"
                                diameter="28"
                                strokeWidth="2"
                            ></mat-progress-spinner>
                            <mat-icon svgIcon="check" class="checkmark"></mat-icon>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description>
                        <div class="title">{{ 'self-serve.quickstart.inviteYourTeam' | translate }}</div>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="panel-content">
                    <mat-action-row>
                        <ui-button
                            [disabled]="
                                onboardingStatus.sendInvitations.isComplete ||
                                onboardingStatus.addYourTeam.percentageComplete !== 100
                            "
                            type="primary"
                            (click)="
                                !onboardingStatus.sendInvitations.isComplete &&
                                    onboardingStatus.addYourTeam.percentageComplete === 100 &&
                                    sendInvites()
                            "
                        >
                            {{ 'self-serve.quickstart.sendInvites' | translate }}
                        </ui-button>
                    </mat-action-row>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </ui-card>
    <ui-card>
        <div class="flex">
            <div>
                <h3>{{ 'self-serve.employeeBenefits.addBenefitsPlanTitle' | translate }}</h3>
                <p class="subtext">{{ 'self-serve.employeeBenefits.addBenefitsPlanDescription' | translate }}</p>
                <ui-button type="link" size="no-padding" (click)="onAddMyBenefitsClick()">{{
                    'self-serve.employeeBenefits.addMyBenefitsInformation' | translate
                }}</ui-button>
            </div>
            <div class="benefits-icon">
                <img src="/assets/illustrations/benefits.png" />
            </div>
        </div>
    </ui-card>
</div>
